import uniqBy from 'lodash/uniqBy'
import sortBy from 'lodash/sortBy'
import type { TCommon } from '~/src/types/common'
import type { TReport } from '~/src/types/reports'

/**
 We want to sort the reports by title. First, we will have reports whose titles
 contain one of these strings, and in this order:
 - Forecast report
 - Forecast
 - Price Forecast
 - Cost model
 All other reports will be sorted alphabetically and added to the end of the list.
 */
export function sortByTitleReport(reports) {
  try {
    const namingConventions = [
      /forecast report/,
      /(?!price )forecast/,
      /price forecast/,
      /cost model/,
      /outlook report/,
    ]
    const namingVideo = 'Client Briefing Q'

    const conventionalReports = []
    let remainingReports = [...reports]?.map((_report) => {
      return { ..._report, report_type: 'default' }
    })

    namingConventions.forEach((pattern) => {
      let reportType: RegExp
      const report = reports.find((_report) => {
        const result = pattern.test(_report?.title?.toLowerCase())
        if (result) {
          reportType = pattern
        }
        return result
      })

      if (report) {
        conventionalReports.push({ ...report, report_type: reportType })
        remainingReports = remainingReports.filter(
          (_report) => _report.id !== report.id,
        )
      }
    })

    let remainingReportsWithOutVideo = remainingReports?.filter(
      (_report) => !_report.title?.includes(namingVideo),
    )

    const reportsVideo = remainingReports?.filter((_report) =>
      _report.title?.includes(namingVideo),
    )

    remainingReportsWithOutVideo = sortBy(
      remainingReportsWithOutVideo,
      (_report) => _report?.title?.toLowerCase(),
    )

    return uniqBy(
      [
        ...conventionalReports,
        ...remainingReportsWithOutVideo,
        ...reportsVideo,
      ],
      'id',
    )
  } catch (_error) {
    logError(_error)
    return reports
  }
}

type TFilteredReportsGroups = { match: TCommon[]; noMatch: TCommon[] }

export function filterReports(
  reports: TCommon[],
  search: string,
): TFilteredReportsGroups {
  return reports.reduce(
    (result, item) => {
      const hasMatchSearch = item.tags.some(
        (tag: { name: string }) => tag.name === search,
      )
      if (hasMatchSearch) {
        result.match.push(item)
      } else {
        result.noMatch.push(item)
      }
      return result
    },
    { match: [], noMatch: [] },
  )
}

export function sortedByForecastsRecycling(reports: TReport[]) {
  const REPORT_TYPES_WITH_ORDER = [
    'price-forecast',
    'cost-model',
    'battery-recycling-capacity-report',
    'battery-recycling-capacity-database',
    'geo-economic-and-policy',
    'forecast-video',
  ]

  return sortBy(reports, (report) => {
    const reportType =
      report.tags.length > 0 ? report.tags.at(0).slug : 'default'
    const index = REPORT_TYPES_WITH_ORDER.indexOf(reportType)
    return index === -1 ? Infinity : index
  })
}
